import React from 'react';
import { MenuItem, Popover } from '@mui/material';
import { DeleteOutline, Preview } from '@mui/icons-material';
import BorderedSection from '../border-section/BorderSection';
import i18n from 'i18';

class UploadLayout extends React.Component {
    // children, onClose, open, handleDeleteFile, handlePreview, error, label
    render() {
        return (
            <BorderedSection>
                {this.props.children}
                <Popover
                    open={Boolean(this.props.open)}
                    onClose={() => this.props.onClose()}
                    anchorEl={this.props.open}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    slotProps={{
                        paper: {
                            "p": 1,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75
                            }
                        }
                    }}
                    style={{ zIndex: 9999 }}
                >
                    <MenuItem
                        onClick={(event) => {
                            this.props.onClose();
                            this.props.handleDeleteFile();
                        }}
                    >
                        <DeleteOutline sx={{ mr: 1 }} />
                        {i18n.t('buttons.delete')}
                    </MenuItem>
                    <MenuItem onClick={this.props.handlePreview}>
                        <Preview sx={{ mr: 1 }} />
                        {i18n.t('buttons.preview')}
                    </MenuItem>
                </Popover>
            </BorderedSection>
        );
    }
}

export default UploadLayout;
